require('./mortgageRequestMortgageEditForm.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { isEmpty } = require('lodash');

// @ utilities
const { formatText } = require('core/i18n').i18n;
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ track processes
const { PROC_CHANGE_MORTGAGE_DATA, PROC_DELETE_MORTGAGE_DATA } = require('constants/mortgageRequestProcesses');

// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const Modal = require('./modal');
const { handleErrors } = require('./handleErrorsMortgageEditForm');
const { buildInfoCalculate, buildInfoActions } = require('./buildsMortgageEditForm');
const { buildOKSelectList, buildAmountInputList } = require('./listComponentsEditForm');
const ModalAbort = require('components/commons/modalAbort/modalAbort');
const { okInsuranceConstants: { insuranceRequestHome } } = require('ok-insurance');

// @actions
const mortgageRequestMortgageDataActions = require('actions/mortgageRequest/mortgageRequestMortgageData');
const mortgageRequestInsurancesActions = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');

// @constants
const {
    FEE_CALCULATE,
    HOME_USE,
    getMortgageInfo,
    NUMBER_BY_NAME_PRODUCT_TYPE_MIXED,
    YEARS_BY_PRODUCT_TYPE
} = require('constants/mortgageRequestMortgageDataTypes');
const documentTypes = require('constants/mortgageRequestDocumentsTypes');

const { APORTAR_DOC } = require('constants/mortgageRequestStates');
const {
    DISCOUNTED_MORTGAGE,
} = require('constants/flagBasedFeatures');
const { MORTGAGE_TYPE } = require('constants/mortgageRequestType')

class MortgageRequestMortgageEditForm extends React.Component {
    constructor(props) {
        super(props);

        const { mortgageDataState, mortgageExtraDataState, mortgageRequestConditions, flagBasedFeatures } = this.props;

        const mData = mortgageDataState.get('data');
        const setPurpose =
            mData.get('finalidad') !== 'UNKNOWN'
                ? mData.get('finalidad')
                : HOME_USE.PRIMERA_VIVIENDA;
        const valEstadoVivienda = mData.get('estadoVivienda', '');
        const valComunidadAutonoma = mData.get('comunidadAutonoma', '');
        const valImporteVivienda = mData.get('importeVivienda', 0);
        const valImporteHipoteca = mData.get('importeHipoteca', 0);
        const valPlazo = mData.get('plazo', 0);
        const valTipoProducto = mData.get('tipoProducto', '');
        const valTipoPlazoFijoMixto = mData.get('tipoPlazoFijoMixto', '');
        const valCuotaMensual = mData.get('cuotaMensual', 0);
        const valCuotaMensualResto = mData.get('cuotaMensualResto');
        const valMultiplierMortgagePrice =
            setPurpose === HOME_USE.PRIMERA_VIVIENDA
                ? FEE_CALCULATE.MULTIPLIER_MORTGAGE_PRICE_FIRST_HOUSING
                : FEE_CALCULATE.MULTIPLIER_MORTGAGE_PRICE_SECOND_HOUSING;
        const valTermMaxAllowed =
            setPurpose === HOME_USE.PRIMERA_VIVIENDA
                ? FEE_CALCULATE.MAX_TERM_ALLOWED_FIRST_HOUSING
                : FEE_CALCULATE.MAX_TERM_ALLOWED_SECOND_HOUSING;
        const valIncluyeSeguroHogar = mortgageRequestConditions.getIn(['conditions', 'incluyeSeguroHogar']);
        const valFixedTerm = mortgageRequestConditions.getIn(['conditions', 'fixedTerm']);
        this.state = {
            estadoVivienda: valEstadoVivienda,
            comunidadAutonoma: valComunidadAutonoma,
            finalidad: setPurpose,
            importeVivienda: valImporteVivienda,
            importeHipoteca: valImporteHipoteca,
            plazo: valPlazo,
            tipoProducto: valTipoProducto,
            tipoPlazoFijoMixto: NUMBER_BY_NAME_PRODUCT_TYPE_MIXED[valFixedTerm],
            incluyeSeguroHogar: valIncluyeSeguroHogar,
            tipoProductoValid: false,
            cuotaMensual: valCuotaMensual,
            cuotaMensualResto: valCuotaMensualResto,
            multiplierMortgagePrice: valMultiplierMortgagePrice,
            termMaxAllowed: valTermMaxAllowed,
            edadmenornm: mortgageExtraDataState.get('edadmenornm'),
            arrayintervinientesimul: mortgageExtraDataState.get('arrayintervinientesimul'),
            confirmDeleteOpen: false,
            confirmed: false,
            isFetching: false,
            isFetchingDelete: false,
            validationErrors: {
                minAge: false,
                maxAge: false,
                importPriceMortgage: false,
                maxImportMortgage: false,
                minImportMortgage: false,
                minImportHousing: false
            },
            cuota: 0,
            cuotaResto: 0,
            isChangeData: false,
            isChangeNewData: false,
            confirmDeleteInsurance: false,
            plazoFijo: valFixedTerm,
        };
        this.estadoVivienda = {
            originalData: valEstadoVivienda,
            initData: valEstadoVivienda,
            newData: valEstadoVivienda
        };
        this.comunidadAutonoma = {
            originalData: valComunidadAutonoma,
            initData: valComunidadAutonoma,
            newData: valComunidadAutonoma
        };
        this.finalidad = {
            originalData: setPurpose,
            initData: setPurpose,
            newData: setPurpose
        };
        this.importeVivienda = {
            originalData: valImporteVivienda,
            initData: valImporteVivienda,
            newData: valImporteVivienda
        };
        this.importeHipoteca = {
            originalData: valImporteHipoteca,
            initData: valImporteHipoteca,
            newData: valImporteHipoteca
        };
        this.plazo = {
            originalData: valPlazo,
            initData: valPlazo,
            newData: valPlazo
        };
        this.tipoProducto = {
            originalData: valTipoProducto,
            initData: valTipoProducto,
            newData: valTipoProducto
        };
        this.tipoPlazoFijoMixto = {
            originalData: valTipoPlazoFijoMixto,
            initData: valTipoPlazoFijoMixto,
            newData: valTipoPlazoFijoMixto
        }
        this.cuotaMensual = {
            initData: valCuotaMensual,
            newData: valCuotaMensual
        };
        this.cuotaMensualResto = {
            initData: valCuotaMensualResto,
            newData: valCuotaMensualResto
        };
        this.multiplierMortgagePrice = {
            initData: valMultiplierMortgagePrice,
            newData: valMultiplierMortgagePrice
        };
        this.termMaxAllowed = {
            initData: valTermMaxAllowed,
            newData: valTermMaxAllowed
        };
        this.incluyeSeguroHogar = {
            originalData: valIncluyeSeguroHogar,
            initData: valIncluyeSeguroHogar,
            newData: valIncluyeSeguroHogar
        };

        this.homeInsuranceEnabled = flagBasedFeatures.get('mortgage-home-insurance-enabled', false);
        this.discountedMortgageAllowed = flagBasedFeatures.get(DISCOUNTED_MORTGAGE);
        this.showRelatedProduct = !this.discountedMortgageAllowed;

        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
        this.handleCloseConfirm = this.handleCloseConfirm.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleConfirmDeleteInsurance = this.handleConfirmDeleteInsurance.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleValidateImport = this.handleValidateImport.bind(this);
        this.handleValidateAge = this.handleValidateAge.bind(this);
        this.handleCalculate = this.handleCalculate.bind(this);
        this.handleCalculateCancel = this.handleCalculateCancel.bind(this);
        this.handleDownloadFipre = this.handleDownloadFipre.bind(this);
        this.handleCancelEdit = this.handleCancelEdit.bind(this);
    }

    componentDidMount() {
        recordProcess(PROC_CHANGE_MORTGAGE_DATA, PROC_START);
        this.handleCalculate();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.mortgageDataState.get('reqFee')) {
            this.setState({
                cuota: nextProps.mortgageDataState.getIn(['feeData', 'cuotaNm'], 0),
                cuotaResto: nextProps.mortgageDataState.getIn(['feeData', 'cuotaNmResto'], 0)
            });
        }
    }

    buildCalculateActions(disabled, loading) {
        return (
            <div className="row calculate">
                <div className="col-md-4 col-md-offset-4">
                    <OKButton
                        block={true}
                        modifier="ghost"
                        onClick={this.handleCalculateCancel}
                    >
                        {formatText('mortgageRequestCommons-cancelText')}
                    </OKButton>
                </div>
                <div className="col-md-4">
                    <OKButton
                        block={true}
                        modifier="primary"
                        disabled={disabled}
                        onClick={this.handleCalculate}
                        loading={loading}
                    >
                        {formatText('mortgageRequestCommons-calcularText')}
                    </OKButton>
                </div>
            </div>
        );
    }

    buildRelatedProducts(isReadOnly) {
        if (this.homeInsuranceEnabled && this.showRelatedProduct) {
            return (
                <div className="row separator">
                    <div className="col-md-12">
                        <OKSelect
                            label={formatText('mortgageRequestMortgageEdit-formSeguroHogarLabel')}
                            name="incluyeSeguroHogar"
                            options={getMortgageInfo().incluyeSeguroHogar}
                            value={this.state.incluyeSeguroHogar}
                            clearable={false}
                            searchable={false}
                            disabled={isReadOnly}
                            errorState={false}
                            errorMessage={formatText('mortgageRequestCommons-defaultFormError')}
                            onChange={(evt) => this.handleSelectChange('incluyeSeguroHogar', evt)}
                        />
                    </div>
                    <ModalAbort
                        titleKey="mortgageRequestMortgageEdit-formSeguroHogarDeleteConfirm"
                        textKey="mortgageRequestMortgageEdit-formSeguroHogarDeleteConfirmText"
                        isOpen={this.state.confirmDeleteInsurance}
                        onAccept={() => this.handleConfirmDeleteInsurance(true)}
                        onCancel={() => this.handleConfirmDeleteInsurance(false)}
                    />
                </div>
            );
        }
    }

    configModalOptions(updateResult) {
        const config = {
            handlers: {
                handleClose: this.handleCloseConfirm,
                handleClickBtn: this.handleCloseConfirm
            },
            text: {
                title: 'other',
                body: 'other',
                button: 'other'
            },
            isDelete: false
        };

        if (this.state.confirmDeleteOpen) {
            config.handlers.handleClickBtn = this.handleDelete;
            config.text.title = 'delete';
            config.text.body = 'delete';
            config.text.button = 'delete';
            config.isDelete = true;
        }

        if (updateResult.add_holder_or_term) {
            config.text.body = 'messageSpecificText1';
        }

        if (updateResult.add_holder_or_contact_us) {
            config.text.body = 'messageSpecificText2';
        }

        if (updateResult.reduce_term) {
            config.text.body = 'messageSpecificText3';
        }

        return config;
    }

    handleCalculate() {
        const valid = this.validateFields();
        if (valid) {
            const plazoFijo = YEARS_BY_PRODUCT_TYPE[this.state.tipoPlazoFijoMixto];
            this.setState({ plazoFijo }, () => {
                this.props.requestMortgageFee(
                    this.state.importeVivienda,
                    this.state.importeHipoteca,
                    this.state.plazo,
                    this.state.tipoProducto,
                    this.props.mortgageRequestState.get('idExpediente'),
                    this.state.incluyeSeguroHogar,
                    this.state.tipoPlazoFijoMixto
                ).then(() => {
                    this.importeVivienda = {
                        originalData: this.importeVivienda.originalData,
                        newData: this.state.importeVivienda,
                        initData: this.state.importeVivienda
                    };
                    this.importeHipoteca = {
                        originalData: this.importeHipoteca.originalData,
                        newData: this.state.importeHipoteca,
                        initData: this.state.importeHipoteca
                    };
                    this.plazo = {
                        originalData: this.plazo.originalData,
                        newData: this.state.plazo,
                        initData: this.state.plazo
                    };
                    this.tipoProducto = {
                        originalData: this.tipoProducto.originalData,
                        newData: this.state.tipoProducto,
                        initData: this.state.tipoProducto
                    };
                    this.incluyeSeguroHogar = {
                        originalData: this.incluyeSeguroHogar.originalData,
                        initData: this.state.incluyeSeguroHogar,
                        newData: this.state.incluyeSeguroHogar
                    };
                    this.tipoPlazoFijoMixto = {
                        originalData: this.tipoPlazoFijoMixto.originalData,
                        initData: this.state.tipoPlazoFijoMixto,
                        newData: this.state.tipoPlazoFijoMixto
                    };
                    this.isValidValues();
                    scrollToTop();
                });
            });
        }
    }

    handleCalculateCancel() {
        this.resetValues();
        this.props.requestMortgageFeeReset();
    }

    handleCancelEdit(evt) {
        evt.preventDefault();
        recordProcess(PROC_CHANGE_MORTGAGE_DATA, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleCloseConfirm(evt) {
        evt && evt.preventDefault();
        const updateResult = this.props.mortgageDataState.get('updateResult').toJS();
        if (
            updateResult.add_holder_or_term ||
            updateResult.add_holder_or_contact_us ||
            updateResult.reduce_term
        ) {
            this.props.resetUpdateResult();
        } else {
            recordProcess(PROC_DELETE_MORTGAGE_DATA, PROC_CANCEL);
            this.setState({ confirmDeleteOpen: false });
        }
    }

    handleConfirm() {
        const showDeleteInsuranceModal = this.incluyeSeguroHogar.originalData && !this.state.incluyeSeguroHogar;

        if (this.homeInsuranceEnabled && this.showRelatedProduct && showDeleteInsuranceModal) {
            this.setState({ confirmDeleteInsurance: true });
        } else {
            this.confirm();
        }
    }

    confirm() {
        const { mortgageRequestState, mortgageDataState, updateMortgage, mortgageInsurancesLink, history } = this.props;

        const valid = this.validateFields();
        const { hasChangedMortgageData, hasChangedData } = this.hasChangedData();

        if (valid) {
            if (!mortgageDataState.get('isFetching')) {
                if (mortgageRequestState.get('estado') === APORTAR_DOC) {
                    if (
                        (!this.homeInsuranceEnabled && !this.showRelatedProduct) ||
                        !hasChangedData ||
                        hasChangedData && hasChangedMortgageData
                    ) {
                        const data = {
                            edadMenor: this.state.edadmenornm,
                            comunidadAutonoma: this.state.comunidadAutonoma,
                            expedienteId: mortgageRequestState.get('idExpediente'),
                            importeHipoteca: this.state.importeHipoteca,
                            importeVivienda: this.state.importeVivienda,
                            intervinientes: this.state.arrayintervinientesimul,
                            plazo: this.state.plazo,
                            simulacion: 1,
                            tipoInmueble: this.state.finalidad,
                            tipoProducto: this.state.tipoProducto,
                            tipoPlazoFijoMixto: this.state.tipoPlazoFijoMixto,
                            tokenUuid: mortgageRequestState.get('token'),
                            viviendaNuevaFl: this.state.estadoVivienda === 'NUEVA' ? true : false,
                            incluyeSeguroHogar: this.incluyeSeguroHogar.initData
                        };

                        const shouldUpdateInsurance = this.homeInsuranceEnabled && this.showRelatedProduct &&
                            this.state.incluyeSeguroHogar !== this.incluyeSeguroHogar.originalData

                        updateMortgage(data, shouldUpdateInsurance, history);
                    } else {
                        mortgageInsurancesLink(this.state.incluyeSeguroHogar, true, history);
                    }
                } else {
                    if (this.showRelatedProduct) {
                        this.homeInsuranceEnabled && mortgageInsurancesLink(this.state.incluyeSeguroHogar, true, history);
                    }
                }
            }
        }
    }

    handleConfirmDelete() {
        recordProcess(PROC_DELETE_MORTGAGE_DATA, PROC_START);
        this.setState({ confirmDeleteOpen: true });
    }

    handleConfirmDeleteInsurance(accept) {
        this.setState({ confirmDeleteInsurance: false });
        if (accept) {
            this.confirm();
        }
    }

    handleDelete() {
        this.props.deleteMortgage(this.props.history);
    }

    handleDownloadFipre(e) {
        e.preventDefault();
        this.props.downloadFipre(documentTypes.FIPRE);
    }

    handleSelectChange(type, evt) {
        this.setState(
            { [type]: evt.value },
            () => {
                if (type === 'finalidad') {
                    const multiplierMortgagePrice = evt.value === HOME_USE.PRIMERA_VIVIENDA ?
                        FEE_CALCULATE.MULTIPLIER_MORTGAGE_PRICE_FIRST_HOUSING :
                        FEE_CALCULATE.MULTIPLIER_MORTGAGE_PRICE_SECOND_HOUSING;
                    const termMaxAllowed = evt.value === HOME_USE.PRIMERA_VIVIENDA ?
                        FEE_CALCULATE.MAX_TERM_ALLOWED_FIRST_HOUSING :
                        FEE_CALCULATE.MAX_TERM_ALLOWED_SECOND_HOUSING;
                    this.setState({
                        multiplierMortgagePrice,
                        termMaxAllowed
                    },
                        () => {
                            this.isValidValues();
                        }
                    );
                }
                if (type === 'tipoProducto' || type === 'incluyeSeguroHogar' || type === 'tipoPlazoFijoMixto') {
                    this.isValidValues();
                }
            });
    }

    handleValidateAge(evt) {
        const plazo = parseInt(evt.target.value, 10) || 0;
        let tipoProducto = '';

        this.setState(
            {
                plazo,
                tipoProducto
            },
            () => {
                this.isValidValues();
            }
        );
    }

    handleValidateImport(type, amount) {
        const parseAmount = parseFloat(amount) || 0;
        this.setState(
            {
                [type]: parseAmount
            },
            () => {
                this.isValidValues();
            }
        );
    }

    isValidValues() {
        const validationErrors = this.state.validationErrors;
        const amountMortgageAllowed =
            this.state.importeVivienda * this.state.multiplierMortgagePrice;
        const minImportHousing = FEE_CALCULATE.MIN_IMPORT_VALUE_ALLOWED * 100 / 80;

        validationErrors.importPriceMortgage = this.state.importeHipoteca > amountMortgageAllowed;
        validationErrors.maxImportMortgage =
            this.state.importeHipoteca > FEE_CALCULATE.MAX_IMPORT_VALUE_ALLOWED;
        validationErrors.minImportMortgage =
            this.state.importeHipoteca < FEE_CALCULATE.MIN_IMPORT_VALUE_ALLOWED;
        validationErrors.minImportHousing = this.state.importeVivienda < minImportHousing;
        validationErrors.minAge = this.state.plazo < FEE_CALCULATE.MIN_TERM_ALLOWED_HOUSING;
        validationErrors.maxAge = this.state.plazo > this.state.termMaxAllowed;

        const isChangeData = (
            (this.importeHipoteca.initData !== this.state.importeHipoteca) ||
            (this.importeVivienda.initData !== this.state.importeVivienda) ||
            (this.plazo.initData !== this.state.plazo) ||
            (this.tipoProducto.initData !== this.state.tipoProducto) ||
            (this.incluyeSeguroHogar.initData !== this.state.incluyeSeguroHogar) ||
            (this.tipoPlazoFijoMixto.initData !== this.state.tipoPlazoFijoMixto)
        );
        const isChangeNewData = (
            (this.importeHipoteca.newData !== this.state.importeHipoteca) ||
            (this.importeVivienda.newData !== this.state.importeVivienda) ||
            (this.plazo.newData !== this.state.plazo) ||
            (this.tipoProducto.newData !== this.state.tipoProducto) ||
            (this.incluyeSeguroHogar.newData !== this.state.incluyeSeguroHogar) ||
            (this.tipoPlazoFijoMixto.initData !== this.state.tipoPlazoFijoMixto)
        );
        this.setState({
            validationErrors,
            isChangeData,
            isChangeNewData
        });
    }

    resetValues() {
        this.estadoVivienda.newData = this.estadoVivienda.initData;
        this.comunidadAutonoma.newData = this.comunidadAutonoma.initData;
        this.finalidad.newData = this.finalidad.initData;
        this.importeVivienda.newData = this.importeVivienda.initData;
        this.importeHipoteca.newData = this.importeHipoteca.initData;
        this.plazo.newData = this.plazo.initData;
        this.tipoProducto.newData = this.tipoProducto.initData;
        this.cuotaMensual.newData = this.cuotaMensual.initData;
        this.incluyeSeguroHogar.newData = this.incluyeSeguroHogar.initData;
        this.tipoPlazoFijoMixto.newData = this.tipoPlazoFijoMixto.initData;

        this.setState(
            {
                estadoVivienda: this.estadoVivienda.initData,
                comunidadAutonoma: this.comunidadAutonoma.initData,
                finalidad: this.finalidad.initData,
                importeVivienda: this.importeVivienda.initData,
                importeHipoteca: this.importeHipoteca.initData,
                plazo: this.plazo.initData,
                tipoProducto: this.tipoProducto.initData,
                cuota: this.cuotaMensual.initData,
                cuotaResto: this.cuotaMensualResto.initData,
                multiplierMortgagePrice: this.multiplierMortgagePrice.initData,
                termMaxAllowed: this.termMaxAllowed.initData,
                incluyeSeguroHogar: this.incluyeSeguroHogar.initData,
                tipoPlazoFijoMixto: this.tipoPlazoFijoMixto.initData
            },
            () => {
                this.isValidValues();
            }
        );
    }

    validateFields() {
        let valid = true;
        const state = {};

        if (isEmpty(this.state.tipoProducto)) {
            state.tipoProductoValid = true;
            valid = false;
        } else {
            state.tipoProductoValid = false;
        }

        !isEmpty(state) && this.setState(state);

        return valid;
    }

    checkIfInsuranceIsRestricted(mortgageState) {
        const { WORKFLOW_STATE } = insuranceRequestHome;

        return WORKFLOW_STATE.includes(mortgageState);
    }

    hasChangedData() {
        const hasChangedMortgageData = (
            this.estadoVivienda.originalData !== this.state.estadoVivienda ||
            this.comunidadAutonoma.originalData !== this.state.comunidadAutonoma ||
            this.finalidad.originalData !== this.state.finalidad ||
            this.importeHipoteca.originalData !== this.state.importeHipoteca ||
            this.importeVivienda.originalData !== this.state.importeVivienda ||
            this.plazo.originalData !== this.state.plazo ||
            this.tipoProducto.originalData !== this.state.tipoProducto ||
            this.tipoPlazoFijoMixto.originalData !== this.state.tipoPlazoFijoMixto
        );

        const hasChangedData = hasChangedMortgageData ||
            this.incluyeSeguroHogar.originalData !== this.state.incluyeSeguroHogar;

        return {
            hasChangedMortgageData,
            hasChangedData
        }
    }

    render() {

        const {
            mortgageDataState,
            mortgageExtraDataState,
            mortgageRequestState,
            mortgageInsuranceManager,
            mortgageRequestConditions
        } = this.props;

        const isFetchingMortgageDataState = mortgageDataState.get('isFetching');
        const mortgageState = mortgageRequestState.get('estado');
        const isReadOnly = mortgageState !== APORTAR_DOC;
        const isInsuranceReadOnly = this.checkIfInsuranceIsRestricted(mortgageState);
        const isReqMortgageDataState = mortgageDataState.get('req');

        if (!isReqMortgageDataState || isFetchingMortgageDataState) {
            return <LoadingSection />;
        }

        const cuotaCurrent = !!this.state.cuota ? this.state.cuota : this.state.cuotaMensual;
        const cuotaRestoCurrent = !!this.state.cuotaResto ? this.state.cuotaResto : this.state.cuotaMensualResto;
        const updateResult = mortgageDataState.get('updateResult');
        const parseUpdateResult = updateResult.toJS();

        const confirmBtnDisabled =
            !this.homeInsuranceEnabled && !this.showRelatedProduct && isReadOnly ||
            this.homeInsuranceEnabled && this.showRelatedProduct && isReadOnly && isInsuranceReadOnly ||
            this.state.validationErrors.importPriceMortgage ||
            this.state.validationErrors.maxImportMortgage ||
            this.state.validationErrors.minImportMortgage ||
            this.state.validationErrors.minAge ||
            this.state.validationErrors.maxAge ||
            mortgageDataState.get('isFetchingUpdate') ||
            mortgageDataState.get('isFetchingFee') ||
            mortgageInsuranceManager.get('isFetchingInsuranceLink');

        const confirmBtnLoading = mortgageDataState.get('isFetchingUpdate') ||
            mortgageDataState.get('isFetchingFee') ||
            mortgageExtraDataState.get('isFetching') ||
            mortgageInsuranceManager.get('isFetchingInsuranceLink');

        const typeErrorHousing = handleErrors(this.state.validationErrors, 'importeVivienda');
        const typeErrorMortgage = handleErrors(this.state.validationErrors, 'importeHipoteca');
        const typeErrorTerm = handleErrors(this.state.validationErrors, 'plazo');
        const calculateActions = this.state.isChangeData ? this.buildCalculateActions(confirmBtnDisabled, confirmBtnLoading) : '';
        const infoRelatedProducts = {
            insurance: this.discountedMortgageAllowed ? mortgageInsuranceManager.get('insuranceConfig').toJS() : false,
        };
        const plazoFijo = this.state.plazoFijo;
        const infoCalculate = this.state.isChangeNewData ?
            buildInfoActions() :
            buildInfoCalculate(cuotaCurrent, cuotaRestoCurrent, this.state, infoRelatedProducts, this.tipoProducto.newData, plazoFijo);
        let modal = '';

        if (
            this.state.confirmDeleteOpen ||
            parseUpdateResult.add_holder_or_term ||
            parseUpdateResult.add_holder_or_contact_us ||
            parseUpdateResult.reduce_term
        ) {
            const modalOptions = this.configModalOptions(parseUpdateResult);
            modal = Modal(modalOptions);
        }

        const mortgageInfo = getMortgageInfo();
        const OKSelectData = [
            {
                label: formatText('mortgageRequestMortgageEdit-formTipoViviendaLabel'),
                name: "estadoVivienda",
                options: mortgageInfo.estadoVivienda,
                value: this.state.estadoVivienda,
                disabled: isReadOnly,
                handleOnChange: (evt) => this.handleSelectChange('estadoVivienda', evt)
            },
            {
                label: formatText('mortgageRequestMortgageEdit-formComunidadAutonomaLabel'),
                name: "comunidadAutonoma",
                options: mortgageInfo.comunidadAutonoma,
                value: this.state.comunidadAutonoma,
                disabled: isReadOnly,
                handleOnChange: (evt) => this.handleSelectChange('comunidadAutonoma', evt)
            },
            {
                label: formatText('mortgageRequestMortgageEdit-formUsoViviendaLabel'),
                name: "finalidad",
                options: mortgageInfo.usoVivienda,
                value: this.state.finalidad,
                disabled: isReadOnly,
                handleOnChange: (evt) => this.handleSelectChange('finalidad', evt)
            }
        ]

        const OKSelectList = buildOKSelectList(OKSelectData);

        const amountInputData = [
            {
                name: "importeVivienda",
                label: formatText('mortgageRequestMortgageEdit-formPrecioLabel'),
                amount: this.state.importeVivienda,
                callback: (amount) => this.handleValidateImport('importeVivienda', amount),
                error: !!typeErrorHousing,
                errorMsg: typeErrorHousing,
                maxFractionLength: 2,
                showBlurZero: true,
                disabled: isReadOnly
            },
            {
                name: "importeHipoteca",
                label: formatText('mortgageRequestMortgageEdit-formImporteHipoteca'),
                amount: this.state.importeHipoteca,
                callback: (amount) => this.handleValidateImport('importeHipoteca', amount),
                error: !!typeErrorMortgage,
                errorMsg: typeErrorMortgage,
                maxFractionLength: 2,
                showBlurZero: true,
                disabled: isReadOnly
            }
        ];

        const amountInputList = buildAmountInputList(amountInputData);
        const editFormSubTitle = isReadOnly ?
            formatText('mortgageRequestMortgageEdit-componentDescriptionReadOnly') :
            formatText('mortgageRequestMortgageEdit-componentDescription');

        const relatedProducts = this.buildRelatedProducts(isInsuranceReadOnly);
        return (
            <React.Fragment>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <ContentBox customClassName="mortgage-request-mortgage-edit-form">
                                    <OKBoxTitle
                                        value={formatText('mortgageRequestMortgageEdit-componentTitle')}
                                        size="medium"
                                        children={editFormSubTitle}
                                    />
                                    <div className="row separator">
                                        <div className="col-md-6">

                                            {OKSelectList}

                                            {amountInputList}

                                            <div className="row separator">
                                                <div className="col-md-12">
                                                    <InputSafe
                                                        label={formatText('mortgageRequestMortgageEdit-formPlazoLabel')}
                                                        name="plazo"
                                                        type="text"
                                                        value={this.state.plazo}
                                                        onChange={this.handleValidateAge}
                                                        errorState={!!typeErrorTerm}
                                                        errorMessage={typeErrorTerm}
                                                        disabled={isReadOnly}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row separator">
                                                <div className="col-md-12">
                                                    <OKSelect
                                                        label={formatText(
                                                            'mortgageRequestMortgageEdit-formTipoHipotecaLabel'
                                                        )}
                                                        name="tipoProducto"
                                                        options={
                                                            this.state.plazo < 6
                                                                ? mortgageInfo.tipoProductoNoMixto
                                                                : mortgageInfo.tipoProducto
                                                        }
                                                        value={this.state.tipoProducto}
                                                        clearable={false}
                                                        searchable={false}
                                                        disabled={isReadOnly}
                                                        errorState={this.state.tipoProductoValid}
                                                        errorMessage={formatText('mortgageRequestCommons-defaultFormError')}
                                                        onChange={(evt) => this.handleSelectChange('tipoProducto', evt)}
                                                    />
                                                </div>
                                            </div>
                                            {this.state.tipoProducto === 'MIXTO' && (
                                                <div className="row separator">
                                                    <div className="col-md-12">
                                                        <OKSelect
                                                            label={formatText(
                                                                'mortgageRequestMortgageEdit-formTipoHipotecaMixtaAniosLabel'
                                                            )}
                                                            name="tipoPlazoFijoMixto"
                                                            options={this.state.plazo >= 6 && this.state.plazo <= 10
                                                                ? mortgageInfo.tipoPlazoFijoMixto5
                                                                : mortgageInfo.tipoPlazoFijoMixto}
                                                            value={this.state.tipoPlazoFijoMixto}
                                                            clearable={false}
                                                            searchable={false}
                                                            disabled={isReadOnly}
                                                            errorState={this.state.tipoPlazoFijoMixtoValid}
                                                            errorMessage={formatText('mortgageRequestCommons-defaultFormError')}
                                                            onChange={(evt) => this.handleSelectChange('tipoPlazoFijoMixto', evt)}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {relatedProducts}
                                            {calculateActions}
                                        </div>
                                        <div className="col-md-5 col-md-offset-1">
                                            <div className="mortgage-request-mortgage-edit-form__quote-data">
                                                {infoCalculate}
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className="row ">
                                        <div className="col-md-6 button-back">
                                            <a
                                                className="ok-link"
                                                href="#"
                                                onClick={this.handleCancelEdit}
                                            >{formatText('mortgageRequestCommons-returnText')}
                                            </a>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-5 col-md-offset-2">
                                                    <OKButton
                                                        modifier="ghost"
                                                        onClick={this.handleConfirmDelete}
                                                        block={true}
                                                    >
                                                        {formatText('mortgageRequestMortgageEdit-buttonDeleteRequest')}
                                                    </OKButton>
                                                </div>
                                                <div className="col-md-5">
                                                    <OKButton
                                                        modifier="primary"
                                                        block={true}
                                                        disabled={confirmBtnDisabled}
                                                        onClick={this.handleConfirm}
                                                        loading={confirmBtnLoading}
                                                        children={formatText('mortgageRequestCommons-confirm')}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {modal}
                                </ContentBox>
                                <p className="mortgage-request-mortgage-edit-form__footer">
                                    {this.state.tipoProducto !== MORTGAGE_TYPE.FIJO && formatText('mortgageRequestMortgageEdit-mortgageModifyLegalText')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div >
            </React.Fragment>
        );
    }
}

MortgageRequestMortgageEditForm.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageDataState: PropTypes.object,
    mortgageExtraDataState: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    mortgageRequestConditions: PropTypes.object,
    mortgageInsuranceManager: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    requestMortgageFee: PropTypes.func,
    requestMortgageFeeReset: PropTypes.func,
    deleteMortgage: PropTypes.func,
    getPersonalData: PropTypes.func,
    updateMortgage: PropTypes.func,
    resetUpdateResult: PropTypes.func,
    downloadFipre: PropTypes.func,
    mortgageInsurancesLink: PropTypes.func,
};

module.exports.constructor = MortgageRequestMortgageEditForm;
module.exports.MortgageRequestMortgageEditForm = connect(
    state => ({
        mortgageDataState: state.mortgageRequestMortgageData,
        mortgageExtraDataState: state.mortgageRequestMortgageExtraData,
        mortgageRequestState: state.mortgageRequestState,
        mortgageRequestConditions: state.mortgageRequestConditions,
        mortgageInsuranceManager: state.mortgageRequestManagerInsuranceRelated,
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        requestMortgageFee: mortgageRequestMortgageDataActions.requestMortgageFee,
        requestMortgageFeeReset: mortgageRequestMortgageDataActions.requestMortgageFeeReset,
        deleteMortgage: mortgageRequestMortgageDataActions.deleteMortgage,
        getPersonalData: mortgageRequestMortgageDataActions.getPersonalData,
        updateMortgage: mortgageRequestMortgageDataActions.updateMortgage,
        resetUpdateResult: mortgageRequestMortgageDataActions.resetUpdateResult,
        downloadFipre: mortgageRequestMortgageDataActions.downloadFipre,
        mortgageInsurancesLink: mortgageRequestInsurancesActions.mortgageRequestInsurancesLink
    }
)(withRouter(MortgageRequestMortgageEditForm));
